import loadable from '@loadable/component';
import { useSelector } from "react-redux";
import { Outlet, Route, Routes } from "react-router-dom";
import {
  APPLICATION_LOCAL_STORAGE
} from "../common/constants/constants";
// import AppLayout from "../components/appLayout";
const AppLayout = loadable(() => import("../components/appLayout"));

import { getEnv } from "../enviroment";
const { authUser } = getEnv();
const PageNotFound = loadable(() => import("../components/pages/pageNotFound"));
const ChatbotUI = loadable(() => import("../components/pages/chatbot-ui"));
const Maintenance = loadable(() => import("../components/maintenance/Maintenance"));
const ServicesMaintenancePage = loadable(() => import("../components/pages/servicesMaintenancePage"));
const NotificationModal = loadable(() => import("../components/notificationModal/NotificationModal"));
const Login = loadable(() => import("../components/pages/login"));
const ChatBotify = loadable(() => import("../components/pages/chatbotify"));
const LogsReview = loadable(() => import("../components/pages/logsReview"));
const LogsReviewQuery = loadable(() => import("../components/pages/logsReview/logsReviewQuery"));
const Users = loadable(() => import("../components/pages/users"));
const Home = loadable(() => import("../components/pages/home"));
const Dashboard = loadable(() => import("../components/pages/dashboard"));
const Prompto = loadable(() => import("../components/pages/prompto"));
const Window = loadable(() => import("../components/pages/window"));
const FileUpload = loadable(() => import("../components/pages/fileUpload"));
const HrArticle = loadable(() => import("../components/pages/hrArticle"));
const Reports = loadable(() => import("../components/pages/reports"));
const PromptAICreateUpdate = loadable(() => import("../components/pages/promptAICreateUpdate/index.jsx"));
const ViewReports = loadable(() =>
  import("../components/pages/reports/viewReport")
);
const UserReports = loadable(() =>
  import("../components/pages/reports/userReport")
);
const TaskPDF = loadable(() => import("../components/pages/taskpdf"))
const ManageUsers = loadable(() => import("../components/pages/manageUsers"));
const ManagePromptAI = loadable(() => import("../components/pages/managePromptAI"));
const ManagePromptAIDetails = loadable(() => import("../components/pages/managePromptAIDetails"));
const AddSuggestion = loadable(() => import('../components/pages/managePromptAIDetails/addSuggestion'));

const ManageChatbot = loadable(() => import("../components/pages/manageChatbot"));
const ManageGlobal = loadable(() =>
  import("../components/pages/manageglobal/ManageGlobalSetting")
);
const ManageRoles = loadable(() => import("../components/pages/roles/index"));
const ChatbotForm = loadable(() => import("../components/pages/chatbotForm"));
const ManageUsersForm = loadable(() =>
  import("../components/pages/manageUsersForm")
);
const Chatbot = loadable(() => import("../components/pages/baseChatbot"));
const AudioGenerator = loadable(() => import("../components/pages/audioGenerator"));
const ManageAuthorAI = loadable(() => import("../components/pages/manageAuthorAI/index.jsx"))
const ManageAuthorAIList = loadable(() => import("../components/pages/manageAuthorAIList/index.jsx"))
const ManageAskYourDataList = loadable(() => import("../components/pages/manageAskYourDataList"))
const ManageAskYourData = loadable(() => import("../components/pages/manageAskYourData"))
const Wrong = loadable(() => import("../components/pages/wrong"));
const Logout = loadable(() => import("../components/pages/logout"));
const KBUtilityRepos = loadable(() => import("../components/pages/kbUtility/kbUtilityRepos"));
const KBUtility = loadable(() => import("../components/pages/kbUtility/kbUtility"));
const KBArticle = loadable(() => import("../components/pages/kbArticle/kbArticle"));
const SmallTalk = loadable(() => import("../components/pages/smallTalk"))
const PageLayout = loadable(() => import("../components/pageLayout"));
const BusinessContinuityMode = loadable(() => import("../components/pages/businessContinuityMode"));
const AuditLogs = loadable(() => import('../components/pages/AuditLogs/AuditLogs.jsx'))
const ViewUserLogs = loadable(() => import('../components/pages/AuditLogs/ViewUserLogs.jsx'));
const TaskvoiceLogs = loadable(() => import('../components/pages/TaskvoiceLogs/TaskvoiceLogs.jsx'));
const ViewTaskvoiceLogs = loadable(() => import('../components/pages/TaskvoiceLogs/ViewTaskvoiceLogs.jsx'))

const TaskScribe = loadable(() => import("../components/pages/taskScribe"));
const WeightedUserStats = loadable(() => import("../components/pages/reports/weightedUserStats/WeightedUserStats.jsx"));
const AssistAiAdoptionFeedback = loadable(() => import("../components/pages/reports/assistAiAdoptionFeedback/AssistAiAdoptionFeedback.jsx"));
// const ProductFeedback = loadable(() => import("../components/pages/reports/productFeedback/ProductFeedback.jsx"));
const ProductFeedbackReport = loadable(() => import("../components/pages/reports/productFeedbackReport/ProductFeedback.jsx"));
const ProtectedRoutes = () => {
  if (window?.location?.pathname === "/chatbot/floatingwidget") {
    window?.location?.assign("/error");
  } else {
    let user = localStorage.getItem(APPLICATION_LOCAL_STORAGE.AUTH_TOKEN);
    return user ? <Outlet /> : window?.location?.assign("/login");
  }
};
const PublicRoutes = () => {
  const notificationData = useSelector(
    (state) => state.notification.notification_modal
  );

  return (
    <>
      <NotificationModal
        isOpen={notificationData?.isOpen}
        message={notificationData?.message}
      />
      <Routes>
        <Route path="/" element={<ProtectedRoutes />}>
          <Route path="">
            <Route index={true} element={<Login />} />
            <Route index={true} element={<Home />} />
          </Route>

          <Route path="/" element={<AppLayout />}>
            <Route path="users">
              <Route index={true} element={<Users />} />
              <Route index={true} element={<Home />} />
            </Route>
            <Route path="home">
              <Route index={true} element={<Home />} />
            </Route>
            <Route path="pagelayout">
              <Route index={true} element={<PageLayout />} />
            </Route>
            <Route path="chatbotify">
              <Route index={true} element={<ChatBotify />} />
            </Route>
            <Route path="manageAskYourData">
              <Route index={true} element={<ManageAskYourData />} />
            </Route>
            <Route path="manageAskYourDataList">
              <Route index={true} element={<ManageAskYourDataList />} />
            </Route>
            <Route path="promptAICreateUpdate">
              <Route index={true} element={<PromptAICreateUpdate />} />
            </Route>
            <Route path="manageAuthorAiList">
              <Route index={true} element={<ManageAuthorAIList />} />
            </Route>
            <Route path="manageAuthorAi">
              <Route index={true} element={<ManageAuthorAI />} />
            </Route>
            {/* <Route path="logsReview">
              <Route index={true} element={<LogsReview />} />
            </Route> */}

            <Route path="">
              <Route index={true} element={<Home />} />
            </Route>
            <Route path="dashboard">
              <Route index={true} element={<Dashboard />} />
            </Route>
            <Route path="prompto">
              <Route index={true} element={<Prompto />} />
            </Route>
            <Route path="taskpdf">
              <Route index={true} element={<TaskPDF />} />
            </Route>
            <Route path="taskaudio">
              <Route index={true} element={<AudioGenerator />} />
            </Route>
            <Route path="window">
              <Route index={true} element={<Window />} />
            </Route>
            <Route path="fileupload">
              <Route index={true} element={<FileUpload />} />
            </Route>
            <Route path="hrArticle">
              <Route index={true} element={<HrArticle />} />
            </Route>
            <Route path="/:chatbot/conversations/:chatId">
              <Route index={true} element={<ChatbotUI />} />
            </Route>
            <Route path="authorAI/:authorAIName">
              <Route index={true} element={<TaskScribe />} />
            </Route>
            <Route path="/:chatbot/chatbot/:chatId">
              <Route index={true} element={<Chatbot />} />
            </Route>
            <Route path="manageChatbot">
              <Route index={true} element={<ManageChatbot />} />
            </Route>
            <Route path="masterConfiguration">
              <Route index={true} element={<SmallTalk />} />
            </Route>
            <Route path="manageUsers">
              <Route index={true} element={<ManageUsers />} />
            </Route>
            <Route path="managePromptAI">
              <Route index={true} element={<ManagePromptAI />} />
            </Route>
            <Route path="managePromptAI/:instanceId">
              <Route index={true} element={<ManagePromptAIDetails />} />
            </Route>
            <Route path="managePromptAI/:instanceId/addSuggestion">
              <Route index={true} element={<AddSuggestion />} />
            </Route>
            <Route path="managePromptAI/:instanceId/updateSuggestion">
              <Route index={true} element={<AddSuggestion />} />
            </Route>
            <Route path="manageroles">
              <Route index={true} element={<ManageRoles />} />
            </Route>
            <Route path="manageglobalsetting">
              <Route index={true} element={<ManageGlobal />} />{" "}
            </Route>
            <Route path="chatbotForm">
              <Route index={true} element={<ChatbotForm />} />
            </Route>
            <Route path="manageUsersForm">
              <Route index={true} element={<ManageUsersForm />} />
            </Route>
            <Route path="chatbot">
              <Route index={true} element={<Chatbot />} />
            </Route>
            <Route path="manageUsers">
              <Route index={true} element={<ManageUsers />} />
            </Route>
            <Route path="manageUsersForm">
              <Route index={true} element={<ManageUsersForm />} />
            </Route>
            <Route path="reports">
              <Route index={true} path="analytics/" element={<Reports />} />
              <Route index={false} path="analytics/view" element={<ViewReports />} />
              <Route index={false} path="observability/user" element={<UserReports />} />
              <Route index={false} path="observability/logs" element={<LogsReview />} />
              <Route index={false} path="query" element={<LogsReviewQuery />} />
              <Route index={false} path="observability/audit-logs" element={<AuditLogs />} />
              <Route index={false} path="audit-logs/:id" element={<ViewUserLogs />} />
              <Route index={false} path="observability/call-ai-logs" element={<TaskvoiceLogs />} />
              <Route index={false} path="call-ai-logs/view-login-logs" element={<ViewTaskvoiceLogs />} />
              <Route index={false} path="call-ai-logs/view-app-logs" element={<ViewTaskvoiceLogs />} />
              <Route index={false} path="call-ai-logs/view-transcript-logs" element={<ViewTaskvoiceLogs />} />
              <Route index={false} path="analytics/weighted-user-stats" element={<WeightedUserStats />} />
              <Route index={false} path="analytics/adoption-feedback-report" element={<AssistAiAdoptionFeedback />} />
              <Route index={false} path="analytics/dashboard" element={<Dashboard />} />
              {/* <Route index={false} path="analytics/product-feedback" element={<ProductFeedback />} /> */}
              <Route index={false} path="analytics/product-feedback" element={<ProductFeedbackReport />} />
            </Route>
            {/* <Route path="kbutilityrepos">
              <Route index={true} element={<KBUtilityRepos />} />
            </Route> */}
            <Route path="kbutility">
              <Route index={true} element={<KBUtilityRepos />} />
            </Route>
            <Route path="kbutility/:reponame">
              <Route index={true} element={<KBUtility />} />
            </Route>
            <Route path="businessContinuityMode">
              <Route index={true} element={<BusinessContinuityMode />} />
            </Route>
            <Route path="kbutility/:reponame/kbarticle">
              <Route index={true} element={<KBArticle />} />
            </Route>
          </Route>
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="chatbot/floatingwidget">
          <Route index={true} element={<ChatbotUI />} />
        </Route>
        <Route path="chatbotfloatingwidget">
          <Route index={true} element={<ChatbotUI />} />
        </Route>
        <Route path="/error" element={<Wrong />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/services-maintenance-inprogress" element={<ServicesMaintenancePage />} />
        <Route path="/maintenance-inprogress" element={<Maintenance />} />
      </Routes>
    </>
  );
};
export default PublicRoutes;
